import React from 'react';
import { useTranslation } from 'react-i18next';
import { OperationPartItem } from '@1po/1po-bff-fe-spec/generated/catalog/easy_basket/response/GetEasyBasketOperationDetailResponse';
import { SFlex } from 'components/ReferencePriceSection/ReferencePriceSection.styled';
import { BRAND_STANDARD_EXCHANGE } from 'domains/easyBasket/EasyBasket.types';
import OperationPart from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/PartsSelection/OperationPart';
import { InfoAlertWrapper } from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/PartsSelection/PartsSelection.styled';
import { getPartPosition } from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/utils';
import { theme } from 'styles';
import { InfoAlert, Text } from 'UI';

const OperationPartItemGroup = ({ itemGroup }: { itemGroup: OperationPartItem }) => {
  const { t } = useTranslation();
  const originalParts = itemGroup.parts.filter((ref) => ref?.brand !== BRAND_STANDARD_EXCHANGE);
  const standardExchangeParts = itemGroup.parts.filter((ref) => ref?.brand === BRAND_STANDARD_EXCHANGE);

  const isOriginalAndStandardExchangePair =
    itemGroup.parts.length === 2 && originalParts.length === 1 && standardExchangeParts.length === 1;

  const showMultiSelectAlert = itemGroup.parts.length > 1 && !isOriginalAndStandardExchangePair;

  return (
    <>
      {showMultiSelectAlert && (
        <InfoAlertWrapper>
          <InfoAlert
            size={'lg'}
            backgroundColor={theme.color.ice_blue}
            message={
              <SFlex direction={'column'}>
                <Text type="base" bold>
                  {t(
                    'catalog.easy_basket.operation_part.multipart.alert.title',
                    'The following elements need your attention',
                  )}
                </Text>
                <Text type={'search_result'}>
                  {t(
                    'catalog.easy_basket.operation_part.multipart.alert.description',
                    'Several References available for the same parts, Please make your selection.',
                  )}
                </Text>
              </SFlex>
            }
          />
        </InfoAlertWrapper>
      )}
      {itemGroup.parts.map((part, index) => (
        <OperationPart
          key={`${part.reference}_${index}`}
          itemGroup={itemGroup.itemGroup}
          multipleReferencesGroup={itemGroup.parts.length > 1}
          mainReferencePosition={getPartPosition(index, itemGroup.parts.length)}
          operationPart={part}
          isOnlyOriginalPartReference={
            isOriginalAndStandardExchangePair && part.reference === originalParts[0]?.reference
          }
        />
      ))}
    </>
  );
};

export default OperationPartItemGroup;
